import React from "react";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { AsVo } from "src/vo/asVo";
import { getCookie } from "src/utils/cookieUtil";
import { EstimateGoods, EstimateVo } from "src/vo/estimateVo";
import { UserVo } from "src/vo/userVo";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

export type userState = {
  readonly title: string;
  readonly count: number;
};

// 1-1. initial state 객체 생성
const initialState: UserVo = {};

export const manageAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  tagTypes: ["UserVo"],
  reducerPath: "manageAPI",
  endpoints: (builder) => ({
    //  ========================= 견적서 상세  =========================
    userList: builder.query({
      query: (index) => ({
        url: ``,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        providesTags: ["UserVo"],
      }),
      transformResponse: (response: any) => response.data,
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
    //  ========================= 견적서 등록  =========================
    addUser: builder.mutation<void, Partial<UserVo>>({
      query: (data) => ({
        url: ``,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
  }),
});

export const { useUserListQuery, useAddUserMutation } = manageAPI;
